const tab_sections = {
    identity: 'Identités',
    integrations: 'Connexions',
    login_security: 'Connexion et sécurité',
    permissions: 'Autorisations',
    automation: 'Automatisation',
    platform: 'Plateforme',
    overview: "Vue d'ensemble",
    authentication: 'Authentification',
    authorization: 'Autorisation',
    users: 'Utilisateurs',
    developer: 'Développeur',
    tenant: 'Locataire',
};
export default Object.freeze(tab_sections);
